import { PortalUtils as portalUtils } from '@powerduck/common/utils/utils';
import jQuery from 'jquery';
import { Tooltip, Popover } from 'bootstrap';
import 'perfect-scrollbar/dist/js/perfect-scrollbar.jquery.min.js';
import 'bootstrap-notify/bootstrap-notify.min.js';

// Bootstrap 5 no longer extends jQuery. Shim $.fn.tooltip and $.fn.popover for legacy code.
if (!(jQuery.fn as any).tooltip) {
	(jQuery.fn as any).tooltip = function (options?: any) {
		return this.each(function (this: HTMLElement) {
			try {
				const existing = Tooltip.getInstance(this);
				if (!existing) {
					new Tooltip(this, options || {});
				}
			} catch (e) { }
		});
	};
}
if (!(jQuery.fn as any).popover) {
	(jQuery.fn as any).popover = function (options?: any) {
		return this.each(function (this: HTMLElement) {
			try {
				const existing = Popover.getInstance(this);
				if (!existing) {
					new Popover(this, options || {});
				}
			} catch (e) { }
		});
	};
}



export namespace DashboardInitializer {
    let $: JQueryStatic = jQuery;
    var transparent = true;
    var transparentDemo = true;
    var fixedTop = false;
    var scroll_distance = null;

    //let _perfectScrollbar: any = require('perfect-scrollbar').default;

    // alert($);
    // alert(_perfectScrollbar);

    var navbar_initialized = false;
    var backgroundOrange = false;
    var sidebar_mini_active = false;
    var toggle_initialized = false;
    var is_iPad = (navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) /* iPad OS 13 */);

    var seq = 0, delays = 80, durations = 500;
    var seq2 = 0, delays2 = 80, durations2 = 500;


    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.

    function debounce(this: any, func, wait, immediate?) {
        var timeout;
        var $this = this;

        return function () {
            var context = $this,
                args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            }, wait);
            if (immediate && !timeout) func.apply(context, args);
        };
    };

    export function disableTransitions() {
        var sheet = window.document.styleSheets[0];
        (sheet as any).insertRule('.main-panel, .main-panel .topnavbar-wrap, .main-panel .content {  transition-property: none !important;   transition-duration: 0.00001s !important;  transition-timing-function: inherit !important }', (sheet as any).cssRules.length);
    }

    export function initialize() {
        $ = window['jQuery'];
        /*!
    
     =========================================================
     * Now UI Dashboard PRO - v1.1.2
     =========================================================
    
     * Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro
     * Copyright 2018 Creative Tim (http://www.creative-tim.com)
    
     * Designed by www.invisionapp.com Coded by www.creative-tim.com
    
     =========================================================
    
     * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
    
     */


        // Default to sidebar-mini (collapsed) unless user explicitly chose expanded ('0')
        if (localStorage.getItem('invMiniSidebar') !== '0') {
            $('body').addClass('sidebar-mini');
            sidebar_mini_active = true;
        }

        // Enable sidebar transitions only after initial layout is settled,
        // so the sidebar-mini width change on load doesn't animate.
        // Double-rAF ensures the first paint (with no transitions) is complete.
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                $('body').addClass('sidebar-ready');
            });
        });

        (function () {
            var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
            var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)

            if (isWindows || !isMobile) {
                $('html').addClass('perfect-scrollbar-on');
                $('.sidebar .sidebar-wrapper')['perfectScrollbar']();

                //setTimeout(function () {
                //    $('html').addClass('perfect-scrollbar-mainbody-on');
                //    $('.main-panel')['perfectScrollbar']();
                //}, 1);
            } else {
                $('html').addClass('perfect-scrollbar-off');
            }

            if (portalUtils.isIOS()) {
                $('html').addClass('ios-device');
            }
        })();

        $(document).ready(function () {
            var $navbar = $('.navbar[color-on-scroll]');
            scroll_distance = $navbar.attr('color-on-scroll') || 500;

            //  Activate the Tooltips
            $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();

            // Activate Popovers and set color for popovers
            $('[data-toggle="popover"]').each(function () {
                var color_class = $(this).data('color');
                $(this).popover({
                    template: '<div class="popover popover-' + color_class + '" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
                });
            });

            var tagClass = $('.tagsinput').data('color');

            if ($(".tagsinput").length != 0) {
                if ($.fn['tagsinput']) {
                    $('.tagsinput')['tagsinput']();
                } else {
                    console.error('Tagsinput plugin not loaded');
                }
            }

            $('.bootstrap-tagsinput').addClass('' + tagClass + '-badge');

            //    Activate bootstrap-select
            if ($(".selectpicker").length != 0) {
                if ($.fn['selectpicker']) {
                    $(".selectpicker")['selectpicker']({
                        iconBase: "now-ui-icons",
                        tickIcon: "ui-1_check"
                    });
                } else {
                    console.error('Selectpicker plugin not loaded');
                }


            }

            if ($('body').hasClass('sidebar-mini')) {
                sidebar_mini_active = true
            }

            $(document).on('hidden.bs.modal', function (event) {
                if ($('.modal:visible').length) {
                    $('body').addClass('modal-open');
                }
            });

            var isWindows = (navigator.platform.indexOf('Win') == 0);
            if (isWindows) {
                $('.modal').on('shown.bs.modal', function () {
                    $('.main-panel')['perfectScrollbar']('destroy');
                }).on('hidden.bs.modal', function () {
                    $('.main-panel')['perfectScrollbar']();
                });
            }

            if ($('.full-screen-map').length == 0 && $('.bd-docs').length == 0) {
                // On click navbar-collapse the menu will be white not transparent
                $('.collapse').on('show.bs.collapse', function () {
                    $(this).closest('.navbar').removeClass('navbar-transparent').addClass('bg-white');
                }).on('hide.bs.collapse', function () {
                    if ($(document).scrollTop() <= scroll_distance) {
                        $(this).closest('.navbar').addClass('navbar-transparent').removeClass('bg-white');
                    }
                });
            }


            // FileInput
            $('.form-file-simple .inputFileVisible').click(function () {
                $(this).siblings('.inputFileHidden').trigger('click');
            });

            $('.form-file-simple .inputFileHidden').change(function () {
                var filename = $(this).val().toString().replace(/C:\\fakepath\\/i, '');
                $(this).siblings('.inputFileVisible').val(filename);
            });
            $('.form-file-simple .inputFileHidden, .form-file-multiple .inputFileHidden').css('z-index', '-1');

            $('.form-file-multiple .inputFileVisible, .form-file-multiple .input-group-btn').click(function () {
                $(this).siblings('.inputFileHidden').trigger('click');
            });

            $('.form-file-multiple .inputFileHidden').change(function () {
                var names = '';
                for (var i = 0; i < $(this).get(0)['files'].length; ++i) {
                    if (i < $(this).get(0)['files'].length - 1) {
                        names += $(this).get(0)['files'].item(i).name + ',';
                    } else {
                        names += $(this).get(0)['files'].item(i).name;
                    }
                }
                $(this).siblings('.inputFileVisible').val(names);
            });

            nowuiDashboard.initMinimizeSidebar();

            // Check if we have the attr "color-on-scroll" then add the function to remove the class "navbar-transparent" so it will transform to a plain color.


            if ($('.navbar[color-on-scroll]').length != 0) {
                nowuiDashboard.checkScrollForTransparentNavbar();
                $(window).on('scroll', nowuiDashboard.checkScrollForTransparentNavbar)
            }

            $('.form-control').on("focus", function () {
                $(this).parent('.input-group').addClass("input-group-focus");
            }).on("blur", function () {
                $(this).parent(".input-group").removeClass("input-group-focus");
            });

            // Activate bootstrapSwitch
            $('.bootstrap-switch').each(function () {
                var $this = $(this);
                var data_on_label = $this.data('on-label') || '';
                var data_off_label = $this.data('off-label') || '';

                if ($this['bootstrapSwitch']) {
                    $this['bootstrapSwitch']({
                        onText: data_on_label,
                        offText: data_off_label
                    });
                }
            });

            if (is_iPad) {
                $('body').removeClass('sidebar-mini');
            }
        });

        $(document).on('click', '.navbar-toggle', function () {
            var $toggle = $(this);

            if (nowuiDashboard.misc.navbar_menu_visible == 1) {
                $('html').removeClass('nav-open');
                nowuiDashboard.misc.navbar_menu_visible = 0;
                setTimeout(function () {
                    $toggle.removeClass('toggled');
                    $('#bodyClick').remove();
                }, 550);

            } else {
                setTimeout(function () {
                    $toggle.addClass('toggled');
                }, 580);

                var div = '<div id="bodyClick"></div>';
                $(div).appendTo('body').click(function () {
                    $('html').removeClass('nav-open');
                    nowuiDashboard.misc.navbar_menu_visible = 0;
                    setTimeout(function () {
                        $toggle.removeClass('toggled');
                        $('#bodyClick').remove();
                    }, 550);
                });

                $('html').addClass('nav-open');
                nowuiDashboard.misc.navbar_menu_visible = 1;
            }
        });
    }

    export var nowuiDashboard = {
        misc: {
            navbar_menu_visible: 0
        },

        checkScrollForTransparentNavbar: debounce(function () {
            if ($(document).scrollTop() > scroll_distance) {
                if (transparent) {
                    transparent = false;
                    $('.navbar[color-on-scroll]').removeClass('navbar-transparent').addClass('bg-white');
                }
            } else {
                if (!transparent) {
                    transparent = true;
                    if ($(".navbar.fixed-top .navbar-toggler[aria-expanded='false']").length !== 0 || $(window).width() > 991) {
                        $('.navbar[color-on-scroll]').addClass('navbar-transparent').removeClass('bg-white');
                    }
                }
            }
        }, 17),

        checkSidebarImage: function () {
            var $sidebar = $('.sidebar');
            var image_src = $sidebar.data('image');

            if (image_src !== undefined) {
                var sidebar_container = '<div class="sidebar-background" style="background-image: url(' + image_src + ') "/>'
                $sidebar.append(sidebar_container);
            }
        },

        initMinimizeSidebar: function () {
            if (is_iPad) {
                $('body').removeClass('sidebar-mini');
            }

            $('#minimizeSidebar').click(function () {
                var $btn = $(this);


                if (!is_iPad) {
                    if (sidebar_mini_active == true) {
                        $('body').removeClass('sidebar-mini');
                        sidebar_mini_active = false;
                        localStorage.setItem('invMiniSidebar', '0');
                    } else {
                        $('body').addClass('sidebar-mini');
                        sidebar_mini_active = true;
                        localStorage.setItem('invMiniSidebar', '1');
                    }
                }

                // we simulate the window Resize so the charts will get updated in realtime.
                var simulateWindowResize = setInterval(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 180);

                // we stop the simulation of Window Resize after the animations are completed
                setTimeout(function () {
                    clearInterval(simulateWindowResize);
                }, 1000);
            });
        },

        startAnimationForLineChart: function (chart) {

            chart.on('draw', function (data) {
                if (data.type === 'line' || data.type === 'area') {
                    data.element.animate({
                        d: {
                            begin: 600,
                            dur: 700,
                            from: (data.path as any).clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                            to: (data.path as any).clone().stringify(),
                            easing: window['Chartist'].Svg.Easing.easeOutQuint
                        }
                    });
                } else if (data.type === 'point') {
                    seq++;
                    data.element.animate({
                        opacity: {
                            begin: seq * delays,
                            dur: durations,
                            from: 0,
                            to: 1,
                            easing: 'ease'
                        }
                    });
                }
            });

            seq = 0;
        },
        startAnimationForBarChart: function (chart) {

            chart.on('draw', function (data) {
                if (data.type === 'bar') {
                    seq2++;
                    data.element.animate({
                        opacity: {
                            begin: seq2 * delays2,
                            dur: durations2,
                            from: 0,
                            to: 1,
                            easing: 'ease'
                        }
                    });
                }
            });

            seq2 = 0;
        },
        showSidebarMessage: function (message) {
            try {
                $['notify']({
                    icon: "now-ui-icons ui-1_bell-53",
                    message: message
                }, {
                    type: 'info',
                    timer: 4000,
                    placement: {
                        from: 'top',
                        align: 'right'
                    }
                });
            } catch (e) {
                console.log('Notify library is missing, please make sure you have the notifications library added.');
            }

        }
    };

    (<any>window)._nowDashboard = nowuiDashboard;

    function hexToRGB(hex, alpha) {
        var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);

        if (alpha) {
            return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
        } else {
            return "rgb(" + r + ", " + g + ", " + b + ")";
        }
    }
}